// 泰语（泰国）
export default {
  company: {
    deviceList: 'รายการอุปกรณ์',
    name: 'คาราเมล ภาพยนตร์',
    desc: 'เพลิดเพลินกับช่วงเวลาดีๆ!',
    companyName: 'ชื่อร้านค้า',
    companyInfo: 'ข้อมูลร้านค้า',
    linkMan: 'ผู้ติดต่อ',
    contactInfo: 'ข้อมูลติดต่อ',
    cooperationWay: 'รูปแบบความร่วมมือ',
    jointOperation: 'ร่วมดำเนินงาน',
    selfOperated: 'ดำเนินการเอง',
    agent: 'ตัวแทน',
    businessStatus: 'สถานะการดำเนินงาน',
    operating: 'กำลังดำเนินงาน',
    stopped: 'หยุดดำเนินงานแล้ว',
    hasBackend: 'เปิดใช้งานแบ็กเอนด์หรือไม่',
    backendAccount: 'บัญชีแบ็กเอนด์',
    backendPassword: 'รหัสผ่านแบ็กเอนด์',
    deviceCount: 'จำนวนเครื่อง',
    orderData: 'ข้อมูลคำสั่งซื้อ',
    companyRatio: 'สัดส่วนร้านค้า (%)',
    operatorRatio: 'สัดส่วนผู้ดำเนินการ (%)',
    companyDesc: 'คำอธิบายร้านค้า',
    companyAddress: 'ที่อยู่ร้านค้า',
    openAggregatedPay: 'เปิดใช้งานการชำระเงินแบบรวมหรือไม่',
    thirdPayWay: 'วิธีการชำระเงินของบุคคลที่สาม',
    merchantId: 'รหัสร้านค้า',
    merchantType: 'ประเภทร้านค้า',
    merchantAppid: 'Appid ของร้านค้า',
    wechatRedirectUrl: 'ที่อยู่ Redirect การชำระเงิน WeChat',
    payNotifyUrl: 'ที่อยู่ Callback การชำระเงิน',
    refundNotifyUrl: 'ที่อยู่ Callback การคืนเงิน',
    sqbMerchantCode: 'รหัสร้านค้า (Shouqianba)',
    sqbDeveloperKey: 'คีย์นักพัฒนา Shouqianba',
    storeActiveCode: 'รหัสเปิดใช้งานร้านค้า',
    frontendCallbackUrl: 'ที่อยู่ Callback ฝั่งหน้าบ้าน',
    merchantSecret: 'Secret ของร้านค้า',
    unit: 'รายการ',
    merchantLevel: 'ระดับร้านค้า',
    level2Merchant: 'ร้านค้าระดับสอง',
    level3Merchant: 'ร้านค้าระดับสาม',
    aggregatedPayMerchant: 'ผู้ค้าการชำระเงินแบบรวม',
    backendOpen: 'เปิดแบ็กเอนด์',
    forwardIncomingPrefix: 'Huilaimi เข้าระบบ_',
    qrCodeGenerateFailed: 'สร้างรหัส QR ล้มเหลว กรุณาลองใหม่',
    invalidWebUrl: 'ที่อยู่เว็บที่ได้รับไม่ถูกต้อง กรุณาติดต่อผู้ดูแลระบบ',
    noValidWebUrl: 'ไม่ได้รับที่อยู่เว็บที่ถูกต้อง',
    fetchDataFailed: 'ดึงข้อมูลล้มเหลว กรุณาลองใหม่',
    browserNotSupportDownload: 'เบราว์เซอร์ของคุณไม่รองรับการดาวน์โหลดอัตโนมัติ กรุณาคลิกขวาเพื่อบันทึกรูปภาพ',
    downloadImageFailed: 'ดาวน์โหลดรูปภาพล้มเหลว กรุณาลองใหม่',
    httpError: 'ข้อผิดพลาด HTTP สถานะ: {status}',
    copyCompanyName: 'คัดลอกชื่อร้านค้า',
    copySuccess: 'คัดลอกสำเร็จ',
    copyFail: 'คัดลอกไม่สำเร็จ'
  },
  income: {
    totalIncome: 'ยอดรวมคำสั่งซื้อ',
    platformIncome: 'ส่วนแบ่งแพลตฟอร์ม',
    companyIncome: 'รายได้ระบบร้านค้า',
    subMerchantIncome: 'ส่วนที่ร้านค้าระดับสามควรได้รับ',
    parentIncome: 'ส่วนคงเหลือของร้านค้าระดับสอง',
    orderCount: 'จำนวนคำสั่งซื้อ',
    subMerchantIncomeDetail: 'รายละเอียดรายได้ร้านค้าระดับสาม',
    subRatioText: 'คงเหลือระดับสาม',
    subJustRatioText: 'ค่าคอมมิชชันระดับสอง',
    splitRatio: 'สัดส่วนการแบ่ง',
    deviceCount: 'จำนวนอุปกรณ์',
    deviceCode: 'รหัสอุปกรณ์',
    deviceName: 'ชื่ออุปกรณ์'
  },
  login: {
    username: 'ชื่อผู้ใช้',
    password: 'รหัสผ่าน',
    login: 'เข้าสู่ระบบ',
    inputUsername: 'กรุณากรอกชื่อผู้ใช้',
    inputPassword: 'กรุณากรอกรหัสผ่าน'
  },
  employee: {
    inputAccount: 'กรุณากรอกบัญชี',
    inputName: 'กรุณากรอกชื่อ',
    inputMobile: 'กรุณากรอกหมายเลขโทรศัพท์',
    selectRole: 'กรุณาเลือกบทบาท',
    allRoles: 'บทบาททั้งหมด',
    allStatus: 'สถานะทั้งหมด',
    collapse: 'ย่อ',
    expand: 'ขยาย',
    employeeCount: 'จำนวนพนักงาน: ',
    addEmployee: '+ เพิ่มพนักงาน',
    account: 'บัญชี',
    name: 'ชื่อ',
    gender: 'เพศ',
    role: 'บทบาท',
    company: 'ร้านค้าที่สังกัด',
    creator: 'ผู้เพิ่ม',
    createTime: 'เวลาเพิ่ม',
    devicePermission: 'สิทธิ์อุปกรณ์',
    deviceCountUnit: '{count} เครื่อง',
    viewAllDevices: 'ดูอุปกรณ์ทั้งหมด',
    disableAccount: 'ปิดใช้งาน',
    resetPassword: 'รีเซ็ตรหัสผ่าน',
    assignDevices: 'จัดสรรอุปกรณ์',
    tip: 'แจ้งเตือน',
    deleteConfirm: 'หลังจากลบบัญชี บัญชีนี้จะไม่สามารถเข้าสู่ระบบได้อีก ยืนยันการลบหรือไม่?',
    employeeName: 'ชื่อพนักงาน: ',
    usernameLabel: 'ชื่อผู้ใช้: ',
    currentPermission: 'สิทธิ์ปัจจุบัน: ',
    assignedDevices: 'จัดสรรแล้ว {count} เครื่อง',
    selectDevice: 'เลือกอุปกรณ์: ',
    selectDevicePlaceholder: 'กรุณาเลือกอุปกรณ์',
    deviceHint: 'การไม่เลือกอุปกรณ์ใด ๆ หมายถึงพนักงานสามารถดูอุปกรณ์ทั้งหมดของบริษัทได้',
    selectAtLeastOneDevice: 'กรุณาเลือกอย่างน้อย 1 เครื่อง',
    assignSuccess: 'จัดสรรอุปกรณ์สำเร็จ',
    assignFailed: 'จัดสรรไม่สำเร็จ',
    loadDeviceInfoFailed: 'โหลดข้อมูลอุปกรณ์ไม่สำเร็จ',
    loadDeviceListFailed: 'โหลดรายการอุปกรณ์ไม่สำเร็จ',
    disableConfirmTitle: 'ยืนยันการปิดใช้งานบัญชีพนักงานนี้หรือไม่?',
    disableConfirmContent: 'หลังปิดใช้งาน พนักงานจะไม่สามารถเข้าสู่ระบบได้',
    disableSuccess: 'ปิดใช้งานสำเร็จ',
    enableConfirmTitle: 'ยืนยันการเปิดใช้งานบัญชีพนักงานนี้หรือไม่?',
    enableConfirmContent: 'หลังเปิดใช้งาน พนักงานจะสามารถเข้าสู่ระบบได้',
    enableSuccess: 'เปิดใช้งานสำเร็จ',
    resetPwdConfirmTitle: 'ยืนยันการรีเซ็ตรหัสผ่านพนักงานนี้หรือไม่?',
    resetPwdConfirmContent: 'หลังรีเซ็ต รหัสผ่านจะกลับเป็นรหัสผ่านเริ่มต้น (JTphoto0515)',
    resetPwdSuccess: 'รีเซ็ตรหัสผ่านสำเร็จ',
    addSuccess: 'เพิ่มพนักงานสำเร็จ',
    updateSuccess: 'แก้ไขพนักงานสำเร็จ',
    addTitle: 'เพิ่มพนักงาน',
    editTitle: 'แก้ไขพนักงาน',
    accountLabel: 'บัญชี:',
    nameLabel: 'ชื่อ:',
    passwordLabel: 'รหัสผ่าน:',
    defaultPwdTip: 'เว้นว่างเพื่อใช้รหัสผ่านเริ่มต้น JTphoto0515',
    defaultPwdPlaceholder: 'เว้นว่างเพื่อใช้รหัสผ่านเริ่มต้น',
    emailLabel: 'อีเมล:',
    emailInvalid: 'กรุณากรอกอีเมลที่ถูกต้อง',
    maxLength50: 'ความยาวต้องไม่เกิน 50 ตัวอักษร',
    mobileLabel: 'โทรศัพท์:',
    mobileInvalid: 'กรุณากรอกหมายเลขโทรศัพท์ที่ถูกต้อง',
    roleSetting: 'บทบาท:',
    statusSetting: 'สถานะ:',
    selectStatus: 'กรุณาเลือกสถานะ',
    genderSetting: 'เพศ:',
    selectGender: 'กรุณาเลือกเพศ',
    deptSetting: 'แผนก:',
    remarkLabel: 'หมายเหตุ:',
    remarkPlaceholder: 'กรุณากรอกหมายเหตุ',
    submit: 'ส่ง',
    save: 'บันทึก',
    usernameRequired: 'ชื่อผู้ใช้ต้องไม่ว่าง',
    usernameMax20: 'ชื่อผู้ใช้ต้องไม่เกิน 20 ตัวอักษร',
    usernameMin4: 'ชื่อผู้ใช้ต้องไม่น้อยกว่า 4 ตัวอักษร',
    usernameExists: 'ขออภัย ชื่อผู้ใช้นี้มีอยู่แล้ว',
    mobileRequired: 'หมายเลขโทรศัพท์ต้องไม่ว่าง!',
    nameRequired: 'ชื่อต้องไม่ว่าง!',
    roleRequired: 'บทบาทต้องไม่ว่าง!'
  },
  homepage: {
    totalIP: 'IP ทั้งหมด',
    todayfc: 'รายได้วันนี้',
    weekQOQ: 'เทียบสัปดาห์',
    dayQOQ: 'เทียบวัน',
    todayCompanyIncome: 'รายได้ร้านค้าวันนี้',
    todayPlatformIncome: 'รายได้แพลตฟอร์มวันนี้',
    todayFlow: 'จำนวนลูกค้าวันนี้',
    todayOrder: 'คำสั่งซื้อวันนี้',
    todayRefundOrder: 'คำสั่งคืนเงินวันนี้',
    machineOnlineCount: 'เครื่องออนไลน์',
    machineOfflineCount: 'เครื่องออฟไลน์',
    totalPlatformIncome: 'รายได้แพลตฟอร์มทั้งหมด',
    totalOperatorIncome: 'ส่วนแบ่งผู้ดำเนินการทั้งหมด',
    totalCompanyIncome: 'รายได้ร้านค้าทั้งหมด',
    totalFlow: 'จำนวนลูกค้าทั้งหมด',
    totalOrder: 'คำสั่งซื้อทั้งหมด',
    totalRefundOrder: 'คำสั่งคืนเงินทั้งหมด',
    usage: 'การใช้งาน',
    incomeAmount: 'จำนวนเงินรายได้',
    flow: 'จำนวนลูกค้า',
    orderCount: 'จำนวนคำสั่งซื้อ',
    todayIncome: 'รายได้วันนี้',
    lastLoginTime: 'เวลาเข้าสู่ระบบล่าสุด',
    canWithdrawalIncome: 'รายได้ที่ถอนได้',
    goodMorning: 'สวัสดีตอนเช้า',
    goodForenoon: 'สวัสดีตอนสาย',
    goodNoon: 'สวัสดีตอนเที่ยง',
    goodAfternoon: 'สวัสดีตอนบ่าย',
    goodEvening: 'สวัสดีตอนเย็น',
    welcome1: 'จิบกาแฟพักผ่อนสักหน่อย ☕',
    welcome2: 'อยากเล่น LOL กับเพื่อนไหม?',
    welcome3: 'อยากเล่น Honor of Kings กับเพื่อนไหม?',
    welcome4: 'ไม่กี่วันก็ดูดีขึ้นอีก 😍',
    welcome5: 'วันนี้เขียน Bug ไปกี่ตัว 🐞?',
    welcome6: 'วันนี้คุยในกลุ่มหรือเปล่า?',
    welcome7: 'วันนี้กินอะไรอร่อยๆ?',
    welcome8: 'วันนี้คุณยิ้มหรือยัง 😊?',
    welcome9: 'วันนี้ช่วยคนอื่นแก้ปัญหาหรือเปล่า?',
    welcome10: 'จะกินอะไรดี?',
    welcome11: 'สุดสัปดาห์ไปดูหนังไหม?',
    dateRange: '{start}~{end}',
    withdraw: 'ถอนเงิน',
    avatarAlt: 'รูปโปรไฟล์',
    noDept: 'ไม่มีแผนก',
    noRole: 'ไม่มีบทบาท',
    firstVisit: 'เยี่ยมชมครั้งแรก',
    todayIp: 'IP วันนี้',
    todayVisit: 'การเข้าชมวันนี้',
    totalVisit: 'การเข้าชมทั้งหมด',
    lowPaperTitle: 'แจ้งเตือนกระดาษถ่ายภาพไม่เพียงพอ',
    lowPaperTip: 'อุปกรณ์ต่อไปนี้เหลือกระดาษถ่ายภาพน้อยกว่า {count} แผ่น กรุณาเติมกระดาษโดยเร็วเพื่อไม่ให้กระทบการใช้งานปกติ!',
    lowPaperDeviceName: 'ชื่ออุปกรณ์',
    lowPaperDeviceCode: 'รหัสอุปกรณ์',
    lowPaperCount: 'จำนวนกระดาษ',
    lowPaperClose: 'ปิด'
  },
  device: {
    companyManage: 'จัดการร้านค้า',
    deviceManage: 'จัดการอุปกรณ์',
    totalDevices: 'จำนวนเครื่องทั้งหมด',
    all: 'ทั้งหมด',
    online: 'ออนไลน์',
    offline: 'ออฟไลน์',
    updating: 'กำลังอัปเดต',
    versionUpdate: 'อัปเดตเวอร์ชัน',
    export: 'ส่งออก',
    batchUpdate: 'อัปเดตเป็นชุด',
    unbind: 'ยกเลิกการผูก',
    bind: 'ผูก',
    companyName: 'ชื่อร้านค้า',
    deviceCode: 'รหัสอุปกรณ์',
    appVersion: 'เวอร์ชันแอป',
    sn: 'หมายเลขซีเรียล',
    uiName: 'ชื่อ UI',
    uiGroupName: 'กลุ่ม UI',
    photoTime: 'เวลาถ่ายภาพ',
    intervalTime: 'ช่วงเวลาถ่ายภาพ',
    pagerNum: 'จำนวนกระดาษ',
    goodsNum: 'จำนวนสินค้า',
    filterNum: 'จำนวนฟิลเตอร์',
    address: 'ที่อยู่ของเครื่อง',
    orderCount: 'จำนวนคำสั่งซื้อ',
    operation: 'การดำเนินการ',
    command: 'ส่งคำสั่งสำเร็จ',
    reset: 'รีเซ็ต',
    restartApp: 'รีสตาร์ทแอป',
    showMenu: 'แสดงเมนู',
    hideMenu: 'ซ่อนเมนู',
    reportLog: 'รายงานล็อก',
    isSupperCoins: 'รองรับเหรียญ',
    unbinded: 'ยกเลิกการผูกแล้ว',
    binded: 'ผูกแล้ว',
    bindStatus: 'สถานะการผูก',
    lastestOnlineTime: 'เวลาออนไลน์ล่าสุด',
    macAddress: 'ที่อยู่ MAC',
    resolution: 'ความละเอียด',
    deviceSN: 'SN อุปกรณ์',
    deviceVersion: 'เวอร์ชันอุปกรณ์',
    deviceKey: 'คีย์อุปกรณ์',
    deviceIMEI: 'IMEI อุปกรณ์',
    activationCode: 'รหัสเปิดใช้งาน',
    leyaoyaoCode: 'รหัส Leyaoyao',
    electronicPhoto: 'ภาพถ่ายอิเล็กทรอนิกส์',
    scanDownload: 'สแกนเพื่อดาวน์โหลด',
    sendFriend: 'ส่งให้เพื่อน',
    templateImage: 'รูปภาพแม่แบบ',
    working: 'กำลังทำงาน',
    workStatus: 'สถานะการทำงาน',
    thumbnail: 'ภาพย่อ',
    remoteCode: 'รหัสระยะไกล',
    belongCategory: 'หมวดหมู่',
    allMerchants: 'ร้านค้าทั้งหมด',
    assign: 'จัดสรร',
    viewOrders: 'ดูคำสั่งซื้อ',
    selectBindMerchant: 'กรุณาเลือกร้านค้าที่ต้องการผูก',
    pendingVendorActive: 'รอเปิดใช้งาน Shouqianba',
    vendorActivationCode: 'รหัสเปิดใช้งาน Shouqianba',
    vendorActivationCodePlaceholder: 'กรุณากรอกรหัสเปิดใช้งาน Shouqianba',
    vendorActivationCodeRequired: 'กรุณากรอกรหัสเปิดใช้งาน Shouqianba',
    merchantName: 'ชื่อร้านค้า',
    selectMerchantName: 'กรุณาเลือกชื่อร้านค้า',
    assignDeviceToSub: 'จัดสรรอุปกรณ์ให้ร้านค้าย่อย',
    deviceLabel: 'อุปกรณ์: ',
    targetMerchant: 'ร้านค้าเป้าหมาย',
    selectSubMerchant: 'กรุณาเลือกร้านค้าย่อย',
    noSubMerchant: 'ไม่มีร้านค้าย่อย กรุณาสร้างร้านค้าระดับ 3 ก่อน',
    selectTargetMerchant: 'กรุณาเลือกร้านค้าเป้าหมาย',
    assignSuccess: 'จัดสรรอุปกรณ์สำเร็จ',
    assignFailed: 'จัดสรรอุปกรณ์ล้มเหลว',
    selectDeviceToUpdate: 'กรุณาเลือกอุปกรณ์ที่ต้องการอัปเดต! อย่างน้อยหนึ่งรายการ',
    setupSuccess: 'ตั้งค่าอุปกรณ์สำเร็จ',
    updateUI: 'อัปเดต UI',
    updateApp: 'อัปเดต APP',
    updateConfig: 'อัปเดตการตั้งค่า',
    shellExec: 'การเรียกใช้คำสั่ง Shell',
    shellCommand: 'คำสั่ง Shell',
    shellCommandPlaceholder: 'กรอกคำสั่ง Shell ที่ต้องการเรียกใช้ เช่น ls -la /tmp',
    sendShellCommand: 'ส่งคำสั่ง Shell',
    dangerousConfirmTip: 'คำสั่งที่อันตรายจำเป็นต้องยืนยัน',
    notifiedUpdateUI: 'แจ้งอุปกรณ์ให้อัปเดต UI แล้ว',
    notifiedUpdateApp: 'แจ้งอุปกรณ์ให้อัปเดต APP แล้ว',
    notifiedUpdateConfig: 'แจ้งอุปกรณ์ให้อัปเดตการตั้งค่าแล้ว',
    inputShellCommand: 'กรุณากรอกคำสั่ง Shell',
    dangerousWarningTitle: '⚠️ คำเตือนการดำเนินการที่อันตราย',
    dangerousWarningContent: 'คุณกำลังเรียกใช้คำสั่งที่อันตราย ซึ่งอาจทำให้อุปกรณ์ผิดปกติ! ต้องการดำเนินการต่อหรือไม่?',
    confirmExecute: 'ยืนยันการดำเนินการ',
    commandSent: 'ส่งคำสั่งแล้ว กรุณารออุปกรณ์ดำเนินการ',
    sendFailed: 'ส่งล้มเหลว',
    networkError: 'เครือข่ายผิดพลาด กรุณาลองใหม่ภายหลัง',
    confirmUnbind: 'หลังจากยกเลิกการผูก อุปกรณ์จะถูกยกเลิกการเชื่อมโยงกับผู้ค้า คุณแน่ใจหรือไม่ว่าต้องการยกเลิกการผูกอุปกรณ์นี้?',
    copyCompanyName: 'คัดลอกชื่อร้านค้า',
    copyDeviceCode: 'คัดลอกรหัสอุปกรณ์',
    copyActiveCode: 'คัดลอกรหัสเปิดใช้งาน',
    copySuccess: 'คัดลอกสำเร็จ',
    copyFail: 'คัดลอกไม่สำเร็จ'
  },
  setting: {
    navbarColor: 'สีแถบนำทาง',
    themeColor: 'สีธีม',
    navbarPosition: 'ตำแหน่งแถบนำทาง',
    fixedTopRail: 'ตรึงแถบด้านบน',
    fixedSidebar: 'ตรึงแถบด้านข้าง',
    multiTabMode: 'โหมดหลายแท็บ',
    languageSwitching: 'เปลี่ยนภาษา',
    userCenter: 'ศูนย์ผู้ใช้',
    updatePassword: 'อัปเดตรหัสผ่าน',
    customSystem: 'ปรับแต่งระบบ',
    logout: 'ออกจากระบบ',
    updateCache: 'อัปเดตแคช',
    refreshCacheSuccess: 'อัปเดตแคชสำเร็จ',
    refreshCacheFailed: 'อัปเดตแคชล้มเหลว'
  },
  common: {
    confirm: 'ยืนยัน',
    cancel: 'ยกเลิก',
    saveSetting: 'บันทึกการตั้งค่า',
    languageChanged: 'เปลี่ยนภาษาสำเร็จ',
    timezoneChanged: 'เปลี่ยนเขตเวลาสำเร็จ',
    search: 'ค้นหา',
    pleaseInputContent: 'กรุณากรอกเนื้อหา',
    export: 'ส่งออก',
    default: 'ค่าเริ่มต้น',
    item: 'รายการ',
    view: 'ดู',
    setup: 'ตั้งค่า',
    status: 'สถานะ',
    showTotal: 'แสดง {start} ~ {end} รายการ จากทั้งหมด {total} รายการ',
    yes: 'ใช่',
    no: 'ไม่ใช่',
    info: 'ข้อมูล',
    sequenceNumber: 'ลำดับ',
    creationTime: 'เวลาสร้าง',
    operation: 'การดำเนินการ',
    defaultSort: 'เรียงลำดับ',
    type: 'ในตัว',
    edit: 'แก้ไข',
    delete: 'ลบ',
    deleteSuccess: 'ลบสำเร็จ',
    editSuccess: 'แก้ไขสำเร็จ',
    updateSuccess: 'อัปเดตสำเร็จ',
    connectionError: 'การเชื่อมต่อเซิร์ฟเวอร์ผิดปกติ กรุณาลองใหม่ภายหลัง!',
    reset: 'รีเซ็ต',
    allCategory: 'หมวดหมู่ทั้งหมด',
    query: 'สอบถาม',
    add: 'เพิ่ม',
    loadError: 'โหลดผิดพลาด',
    isDefault: 'ค่าเริ่มต้น',
    setDefault: 'ตั้งเป็นค่าเริ่มต้น',
    cancelDefault: 'ยกเลิกค่าเริ่มต้น',
    batchEdit: 'แก้ไขเป็นชุด',
    back: 'กลับ',
    uploadImg: 'อัปโหลดรูปภาพ',
    uploadImgSuccess: 'อัปโหลดรูปภาพสำเร็จ',
    uploadImgFailed: 'อัปโหลดล้มเหลว',
    uploadImgTips1: 'อนุญาตเฉพาะรูปแบบ JPG, JPEG, GIF, PNG เท่านั้น',
    uploadImgTips2: 'ไฟล์เกินขีดจำกัด 10M ไม่อนุญาตให้อัปโหลด',
    addSuccess: 'เพิ่มสำเร็จ',
    all: 'ทั้งหมด',
    batchAdd: 'เพิ่มเป็นชุด',
    deleteError: 'ลบล้มเหลว',
    deleteNoData: 'กรุณาเลือกข้อมูลที่ต้องการลบ',
    disable: 'ปิดใช้งาน',
    enable: 'เปิดใช้งาน',
    exportError: 'ส่งออกล้มเหลว!',
    exportExecl: 'ส่งออก Excel',
    exportSuccess: 'ส่งออกสำเร็จ',
    noData: 'ไม่มีข้อมูล',
    operateError: 'ดำเนินการล้มเหลว กรุณาลองใหม่',
    prompt: 'เคล็ดลับ',
    searchError: 'ค้นหาล้มเหลว',
    selectDataFirst: 'กรุณาเลือกสติ๊กเกอร์ที่ต้องการส่งออกก่อน!',
    uploadError: 'อัปโหลดล้มเหลว',
    selectAll: 'เลือกทั้งหมด',
    totalRecords: 'ทั้งหมด {total} รายการ',
    closeLeft: 'ปิดด้านซ้าย',
    closeRight: 'ปิดด้านขวา',
    closeOthers: 'ปิดอื่นๆ'
  },
  template: {
    merchantManagement: 'จัดการร้านค้า',
    uiManagement: 'จัดการ UI',
    newConfig: 'กรอบใหม่',
    editFrame: 'แก้ไขกรอบ',
    editConfig: 'แก้ไขการตั้งค่า',
    top: 'ด้านบน',
    bottom: 'ด้านล่าง',
    builtIn: 'ในตัว',
    nonBuiltIn: 'ไม่ใช่ในตัว',
    uiConfigName: 'ชื่อ UI',
    background: 'พื้นหลัง',
    wechatOfficialAccount: 'คิวอาร์โค้ด',
    title: 'ชื่อเรื่อง',
    banner: 'แบนเนอร์',
    creationTime: 'เวลาสร้าง',
    indicatorColor: 'สีตัวบ่งชี้',
    type: 'ประเภท',
    appliedMachines: 'เครื่องที่ใช้',
    freamName: 'ชื่อกรอบรูป',
    editSuccess: 'แก้ไข UI สำเร็จ',
    tip: 'เคล็ดลับ',
    deletePrompt: 'การลบการตั้งค่า UI นี้จะทำให้ผู้ใช้ไม่สามารถใช้งานได้ คุณแน่ใจหรือไม่ว่าต้องการลบ?',
    matchProduct: 'จับคู่สินค้า',
    selectProduct: 'กรุณาเลือกสินค้า',
    templateFilePng: 'ไฟล์แม่แบบ PNG',
    maxFileSize: 'ขนาดไฟล์สูงสุด 10M',
    addUploadImage: 'เพิ่มรูปภาพอัปโหลด',
    previewImage: 'รูปภาพตัวอย่าง',
    cuttingImage: 'ภาพตัดแต่ง',
    groupPhotoFrame: 'กรอบรูปถ่ายร่วม',
    groupPhotoYes: 'ถ่ายร่วม',
    groupPhotoNo: 'ไม่ถ่ายร่วม',
    groupPhotoLensSetting: 'ตั้งค่ารายละเอียดเลนส์ถ่ายร่วม',
    groupPhotoConfigured: 'ตั้งค่าภาพถ่ายร่วมแล้ว',
    groupPhotoNotSet: 'ยังไม่ได้ตั้งค่าภาพถ่ายร่วม',
    buttonNormal: 'ปุ่มปกติ',
    buttonPressed: 'ปุ่มกด',
    buttonNormalExample: 'ตัวอย่างปุ่มปกติ',
    buttonPressedExample: 'ตัวอย่างปุ่มกด',
    reuseTemplateFile: 'ใช้ไฟล์เทมเพลตซ้ำ',
    reuseNormalButton: 'ใช้ปุ่มปกติซ้ำ',
    reuseAllTemplateFiles: 'ใช้ไฟล์เทมเพลตซ้ำทั้งหมด',
    addSticker: 'เพิ่มสติ๊กเกอร์',
    editSticker: 'แก้ไขสติ๊กเกอร์',
    StickerIndexNum: 'หมายเลขดัชนี',
    onlyImage: 'อัปโหลดได้เฉพาะรูปภาพ JPG, JPEG, GIF และ PNG เท่านั้น',
    selectCategory: 'กรุณาเลือกหมวดหมู่',
    selectStatus: 'กรุณาเลือกสถานะ',
    selectType: 'กรุณาเลือกประเภท',
    stickerCategory: 'หมวดหมู่สติ๊กเกอร์',
    stickerCode: 'รหัสสติ๊กเกอร์',
    stickerFileSize: 'ขนาดไฟล์',
    stickerName: 'ชื่อสติ๊กเกอร์',
    stickerPreview: 'รูปภาพสติ๊กเกอร์',
    stickerStatus: 'สถานะ',
    stickerType: 'ประเภท',
    staticSticker: 'สติ๊กเกอร์ภาพนิ่ง',
    gifSticker: 'ภาพเคลื่อนไหว GIF',
    videoSticker: 'สติ๊กเกอร์วิดีโอ',
    frameGroup: 'กลุ่มกรอบรูป'
  },
  sticker: {
    stickerPreview: 'รูปภาพสติ๊กเกอร์',
    stickerCode: 'รหัสสติ๊กเกอร์',
    stickerCategory: 'หมวดหมู่สติ๊กเกอร์',
    stickerType: 'ประเภท',
    stickerSize: 'ขนาด',
    stickerFileSize: 'ขนาดไฟล์',
    StickerIndexNum: 'หมายเลขดัชนี',
    stickerStatus: 'สถานะ',
    stickerName: 'ชื่อสติ๊กเกอร์',
    stickerOperation: 'การดำเนินการ',
    addSticker: 'เพิ่มสติ๊กเกอร์',
    stickerImage: 'รูปภาพสติ๊กเกอร์',
    stickerThumbnail: 'ภาพย่อ',
    stickerWidth: 'ความกว้าง (พิกเซล)',
    stickerHeight: 'ความสูง (พิกเซล)',
    stickerDuration: 'ระยะเวลา',
    stickerTags: 'แท็ก',
    stickerDescription: 'คำอธิบาย',
    statusTips: 'กรุณาเลือกสถานะ',
    typeTips: 'กรุณาเลือกประเภท',
    categoryTips: 'กรุณาเลือกหมวดหมู่',
    editSticker: 'แก้ไขสติ๊กเกอร์',
    imgPreview: 'ตัวอย่างรูปภาพ',
    codeCheckResultErr: '❌ รหัสนี้มีอยู่แล้ว กรุณาเปลี่ยน',
    codeCheckResultOk: '✅ รหัสใช้งานได้',
    inputCodeTips: 'ไม่บังคับ อุปกรณ์แยกประเภทสติกเกอร์ตาม suffix ของรหัส (เช่น ST2D) แนะนำตัวพิมพ์ใหญ่ ตัวเลข และขีดล่าง',
    categoryIcon: 'ไอคอนหมวดหมู่',
    categoryName: 'ชื่อหมวดหมู่',
    categoryCode: 'รหัสหมวดหมู่',
    categoryIconPlaceholder: 'กรุณากรอก URL ไอคอน',
    addCategory: 'เพิ่มหมวดหมู่',
    editCategory: 'แก้ไขหมวดหมู่',
    groupNewAdd: 'เพิ่มกลุ่มใหม่',
    groupEdit: 'แก้ไขกลุ่ม',
    groupName: 'ชื่อกลุ่ม',
    groupCode: 'รหัสกลุ่ม',
    groupIcon: 'ไอคอนกลุ่ม',
    hasSticker: 'จำนวนสติ๊กเกอร์',
    groupCodePlaceholder: 'กรุณากรอกรหัสกลุ่ม (ภาษาอังกฤษตัวพิมพ์ใหญ่)',
    groupNamePlaceholder: 'กรุณากรอกชื่อกลุ่ม',
    groupDescriptionPHR: 'กรุณากรอกคำอธิบายกลุ่ม',
    controllerSticker: 'ควบคุม',
    addFailed: 'เพิ่มล้มเหลว',
    addSuccess: 'เพิ่มสำเร็จ',
    confirmDeleteSticker: 'คุณแน่ใจหรือไม่ว่าต้องการลบสติ๊กเกอร์นี้?',
    deleteFailed: 'ลบล้มเหลว',
    deleteSuccess: 'ลบสำเร็จ',
    fileDurationDesc: 'สำหรับวิดีโอ/GIF เท่านั้น ไม่บังคับ',
    fileDurationTips: 'จำเป็นต้องกรอกเฉพาะสติ๊กเกอร์วิดีโอ/GIF',
    fileSizeDesc: 'ระบบจะกรอกให้อัตโนมัติหลังอัปโหลด',
    fileSizeExample: 'เช่น: 51200',
    heightExample: 'เช่น: 200',
    widthExample: 'เช่น: 200',
    selectAtLeastOne: 'กรุณาเลือกสติ๊กเกอร์อย่างน้อยหนึ่งรายการ',
    selectSticker: 'เลือกสติ๊กเกอร์',
    stickerCodeDesc: 'ตัวระบุที่ไม่ซ้ำกันทั้งระบบ แนะนำให้ใช้รูปแบบ STICKER_XXX',
    stickerCodeTips: 'กรุณากรอกรหัสสติ๊กเกอร์ (ไม่ซ้ำกัน)',
    stickerImageSize: 'ขนาดที่แนะนำ: 200x200 พิกเซล รองรับรูปแบบ PNG, JPG',
    stickerSlected: 'สติ๊กเกอร์ที่เลือก',
    thumbnail: 'ภาพย่อ',
    uploadStickerImage: 'กรุณาอัปโหลดรูปภาพสติ๊กเกอร์',
    inputStickerName: 'กรุณากรอกชื่อสติ๊กเกอร์',
    inputStickerCode: 'กรุณากรอกรหัสสติ๊กเกอร์',
    codeFormatTips: 'แนะนำรูปแบบ STICKER_XXX',
    codeExists: 'รหัสสติ๊กเกอร์นี้มีอยู่แล้ว กรุณาเปลี่ยน',
    codeValidateFailed: 'การตรวจสอบล้มเหลว',
    codeValidateError: 'ตรวจสอบรหัสล้มเหลว กรุณาลองใหม่',
    codeFormatError: 'รูปแบบรหัสไม่ถูกต้อง แนะนำรูปแบบ STICKER_XXX',
    codeCheckFailedRetry: 'การตรวจสอบล้มเหลว กรุณาลองใหม่',
    tagsPlaceholder: 'คั่นแท็กหลายรายการด้วยเครื่องหมายจุลภาค เช่น: แฮปปี้, อีโมจิ, ยิ้ม',
    tagsDesc: 'ใช้สำหรับการค้นหาและการจัดหมวดหมู่',
    descPlaceholder: 'กรุณากรอกคำอธิบายสติ๊กเกอร์',
    uploadImage: 'อัปโหลดรูป',
    uploadThumbnail: 'อัปโหลดภาพย่อ',
    reuseStickerImage: 'ใช้ภาพสติกเกอร์ซ้ำ',
    reuseStickerImageTip: 'ภาพย่อจะใช้ภาพสติกเกอร์โดยตรง ไม่ต้องอัปโหลดแยกต่างหาก',
    thumbnailOptional: 'ไม่บังคับ ระบบสามารถสร้างให้อัตโนมัติ',
    thumbnailUploadSuccess: 'อัปโหลดภาพย่อสำเร็จ',
    selectCategoryAttr: 'กรุณาเลือกหมวดหมู่',
    completeFormInfo: 'กรุณากรอกข้อมูลที่จำเป็นในแบบฟอร์มให้ครบ',
    sortOrderPlaceholder: 'ตัวเลขน้อยยิ่งอยู่ด้านบน',
    categoryCodePlaceholder: 'กรุณากรอกรหัสหมวดหมู่ (ภาษาอังกฤษตัวพิมพ์ใหญ่)',
    categoryCodeDesc: 'ตัวระบุที่ไม่ซ้ำ แนะนำภาษาอังกฤษตัวพิมพ์ใหญ่ เช่น: HOT, CUTE',
    inputCategoryName: 'กรุณากรอกชื่อหมวดหมู่',
    inputCategoryCode: 'กรุณากรอกรหัสหมวดหมู่',
    categoryCodePatternMsg: 'กรุณากรอกภาษาอังกฤษตัวพิมพ์ใหญ่ สามารถมีขีดล่างได้',
    categoryCodeExists: 'รหัสหมวดหมู่นี้มีอยู่แล้ว กรุณาเปลี่ยน',
    uploadCategoryIcon: 'กรุณาอัปโหลดไอคอนหมวดหมู่',
    sortOrderMustNumber: 'ลำดับต้องเป็นตัวเลข',
    categoryDescPlaceholder: 'กรุณากรอกคำอธิบายหมวดหมู่',
    confirmDeleteCategory: 'ยืนยันการลบหมวดหมู่นี้?',
    exportDeveloping: 'ฟังก์ชันส่งออกอยู่ระหว่างพัฒนา...',
    confirmDeleteGroup: 'คุณแน่ใจหรือไม่ว่าต้องการลบกลุ่มนี้?',
    selectGroupToDelete: 'กรุณาเลือกกลุ่มที่ต้องการลบ',
    inputGroupName: 'กรุณากรอกชื่อกลุ่ม',
    groupNameTooLong: 'ชื่อกลุ่มต้องไม่เกิน 50 ตัวอักษร',
    inputGroupCode: 'กรุณากรอกรหัสกลุ่ม',
    groupCodeFormatMsg: 'รหัสกลุ่มต้องมีเฉพาะภาษาอังกฤษตัวพิมพ์ใหญ่ ตัวเลข และขีดล่าง',
    groupCodeTooLong: 'รหัสกลุ่มต้องไม่เกิน 50 ตัวอักษร',
    groupCodeInvalidOrExists: 'รูปแบบรหัสกลุ่มไม่ถูกต้องหรือมีอยู่แล้ว กรุณาตรวจสอบ',
    uploadGroupIcon: 'กรุณาอัปโหลดไอคอนกลุ่ม',
    sortOrderInvalid: 'กรุณากรอกลำดับที่ถูกต้อง (ตัวเลขตั้งแต่ 0 ขึ้นไป)',
    selectStatusEnableDisable: 'กรุณาเลือกสถานะ (เปิดใช้งาน/ปิดใช้งาน)',
    codeCheckErrorTips: '⚠️ การตรวจสอบรหัสล้มเหลว กรุณาลองใหม่ภายหลัง',
    editFailed: 'แก้ไขล้มเหลว',
    operationFailedRetry: 'ดำเนินการล้มเหลว กรุณาลองใหม่',
    apiException: 'เกิดข้อผิดพลาดของระบบ',
    selectStickerType: 'กรุณาเลือกประเภทสติ๊กเกอร์'
  },
  filter: {
    filterName: 'ชื่อฟิลเตอร์',
    addFilter: '+ เพิ่มฟิลเตอร์',
    addFilterTitle: 'เพิ่มฟิลเตอร์',
    editFilterTitle: 'แก้ไขฟิลเตอร์',
    filterPreview: 'ตัวอย่างฟิลเตอร์',
    filterOriginalImage: 'ภาพต้นฉบับของฟิลเตอร์',
    filterResourceFile: 'ไฟล์ทรัพยากรฟิลเตอร์',
    belongCompany: 'ร้านค้า',
    allMerchants: 'ทุกร้านค้า',
    type: 'ประเภท',
    builtIn: 'ในตัว',
    nonBuiltIn: 'ไม่ใช่ในตัว',
    appliedMachines: 'จำนวนเครื่องที่ใช้งาน',
    defaultSort: 'ลำดับ',
    serialNo: 'เลขที่',
    batchCopy: 'ทำสำเนายกชุด',
    copy: 'ทำสำเนา',
    tip: 'คำแนะนำ',
    deletePrompt: 'การลบฟิลเตอร์นี้จะทำให้เครื่องไม่สามารถใช้งานฟิลเตอร์นี้ได้ ยืนยันการลบหรือไม่?',
    editFilterSuccess: 'แก้ไขฟิลเตอร์สำเร็จ',
    loadCompanyFailed: 'โหลดรายการร้านค้าไม่สำเร็จ',
    copyFilterSuccess: 'ทำสำเนาฟิลเตอร์สำเร็จ',
    copyFilterFailed: 'ทำสำเนาฟิลเตอร์ไม่สำเร็จ',
    batchCopySuccess: 'ทำสำเนาฟิลเตอร์ยกชุดสำเร็จ',
    batchCopyFailed: 'ทำสำเนาฟิลเตอร์ยกชุดไม่สำเร็จ',
    selectFilterFirst: 'โปรดเลือกฟิลเตอร์ที่จะทำสำเนาก่อน',
    copyToMerchantTitle: 'ทำสำเนาฟิลเตอร์ให้ร้านค้า',
    batchCopyTitle: 'ทำสำเนาฟิลเตอร์ยกชุดให้ร้านค้า',
    originalFilterName: 'ชื่อฟิลเตอร์เดิม',
    newFilterName: 'ชื่อฟิลเตอร์ใหม่',
    inputNewFilterName: 'โปรดกรอกชื่อฟิลเตอร์ใหม่',
    targetMerchant: 'ร้านค้าปลายทาง',
    selectCompany: 'โปรดเลือกร้านค้า',
    selectedFilters: 'ฟิลเตอร์ที่เลือก',
    nameSuffix: 'ชื่อต่อท้ายเดียวกัน',
    inputNameSuffix: 'โปรดกรอกชื่อต่อท้ายเดียวกัน',
    nameSuffixTip: 'ชื่อฟิลเตอร์ใหม่ = ชื่อฟิลเตอร์เดิม + ชื่อต่อท้ายนี้',
    inputFilterName: 'โปรดกรอกชื่อฟิลเตอร์',
    inputName: 'โปรดกรอกชื่อ',
    selectTypeMsg: 'โปรดเลือกประเภท',
    inputDefaultSort: 'โปรดกรอกลำดับ',
    colorMatrix: 'เมทริกซ์สี',
    whitening: 'ผิวขาว',
    smoothing: 'ปรับผิวเรียบ',
    bigEye: 'ตาใหญ่',
    thinFace: 'หน้าเรียว',
    smallFace: 'หน้าเล็ก',
    forehead: 'หน้าผาก',
    cheekbone: 'โหนกแก้ม',
    nose: 'จมูก',
    mouth: 'ปาก',
    chin: 'คาง',
    intensity: 'ความแรงฟิลเตอร์',
    sampleFullColor: 'ตัวอย่างสีเต็ม:',
    colorModeExample: 'ภาพตัวอย่างโหมดสี',
    pngFilterExample: 'ภาพตัวอย่างฟิลเตอร์ PNG ต้นฉบับ',
    anyFormatMax10M: 'ทุกรูปแบบ ไม่เกิน 10MB',
    colorModeNormal: 'โหมดสี - ปกติ:',
    colorModePressed: 'โหมดสี - กด:',
    reuseAllSampleColor: 'ใช้ตัวอย่างสีเต็มซ้ำทั้งหมด',
    addUploadImage: 'เพิ่มและอัปโหลดรูปภาพ',
    uploadFile: 'อัปโหลดไฟล์',
    reupload: 'อัปโหลดใหม่',
    submit: 'ส่ง',
    btnNormalRequired: 'ภาพโหมดสี - ปกติ ห้ามว่าง!',
    imageUrlRequired: 'ภาพตัวอย่างสีเต็ม ห้ามว่าง!',
    filterPngRequired: 'ภาพต้นฉบับฟิลเตอร์ ห้ามว่าง!',
    btnSelectedRequired: 'ภาพโหมดสี - กด ห้ามว่าง!',
    exceed10M: 'เกินขีดจำกัด 10MB ไม่สามารถอัปโหลดได้~',
    uploadFailed: 'อัปโหลดไม่สำเร็จ'
  },
  goods: {
    productName: 'ชื่อสินค้า',
    newProductName: 'ชื่อสินค้าใหม่',
    productCode: 'รหัสสินค้า',
    preview: 'ตัวอย่าง',
    width: 'ความกว้าง',
    height: 'ความสูง',
    imageCount: 'จำนวนภาพถ่าย',
    frameTop: 'ขอบบนกรอบ',
    frameBottom: 'ขอบล่างกรอบ',
    frameLeft: 'ขอบซ้ายกรอบ',
    frameRight: 'ขอบขวากรอบ',
    frameCount: 'จำนวนกรอบ',
    printMode: 'โหมดพิมพ์',
    orientation: 'ทิศทาง',
    price: 'ราคา',
    companyPrice: 'กำหนดราคา',
    increasePrice: 'พิมพ์เพิ่ม',
    defaultIncreasePrice: 'ราคาพิมพ์เพิ่ม',
    companyIncreasePrice: 'กำหนดราคาพิมพ์เพิ่ม',
    type: 'ประเภท',
    deviceCount: 'จำนวนอุปกรณ์',
    operation: 'การดำเนินการ',
    confirmDelete: 'หลังจากลบแล้ว เครื่องจะไม่สามารถเลือกใช้นี้ได้ คุณแน่ใจหรือไม่ว่าต้องการลบ?',
    view: 'ดู',
    edit: 'แก้ไข',
    delete: 'ลบ',
    search: 'ค้นหา',
    addProduct: '+ เพิ่มสินค้า',
    pleaseInputContent: 'กรุณากรอกเนื้อหาการค้นหา',
    sequenceNumber: 'ลำดับ',
    printingMode: 'โหมดพิมพ์',
    oneCopyInDuplicate: 'สำเนาเดียว',
    inDuplicate: 'ทำสำเนา',
    vertical: 'แนวตั้ง',
    horizontal: 'แนวนอน',
    riceConfirmation: 'กรุณากรอกราคาที่ถูกต้อง! ต้องมากกว่าหรือเท่ากับ 0.01!',
    cannotEditBuiltIn: 'ผลิตภัณฑ์ในตัวไม่สามารถแก้ไขได้ เฉพาะ supperAdmin เท่านั้นที่สามารถแก้ไขได้',
    cannotDeleteBuiltIn: 'ผลิตภัณฑ์ในตัวไม่สามารถลบได้ เฉพาะ supperAdmin เท่านั้นที่สามารถลบได้',
    copy: 'คัดลอก',
    copyProduct: 'คัดลอกผลิตภัณฑ์',
    originalProductName: 'ชื่อผลิตภัณฑ์เดิม',
    inputProductName: 'กรุณากรอกชื่อผลิตภัณฑ์ใหม่',
    selectCompany: 'กรุณาเลือกร้านค้า',
    copySuccess: 'คัดลอกผลิตภัณฑ์สำเร็จ',
    frameManage: 'จัดการกรอบรูป',
    orderNum: 'ลำดับ',
    belongCategory: 'หมวดหมู่',
    belongCompany: 'ร้านค้า',
    subCategory: 'หมวดหมู่ย่อย',
    groupName: 'ชื่อกลุ่ม'
  },
  order: {
    orderManagement: 'จัดการคำสั่งซื้อ',
    orderList: 'รายการคำสั่งซื้อ',
    all: 'ทั้งหมด',
    paid: 'ชำระเงินแล้ว',
    completed: 'เสร็จสมบูรณ์',
    unpaid: 'ยังไม่ชำระ',
    refunded: 'คืนเงินแล้ว',
    timeout: 'หมดเวลา',
    canceled: 'ยกเลิกแล้ว',
    paying: 'กำลังชำระเงิน',
    unclose: 'ยังไม่ปิด',
    closed: 'ปิดแล้ว',
    toBeReversed: 'รอการย้อนกลับ',
    reversed: 'ย้อนกลับแล้ว',
    evaluated: 'ประเมินแล้ว',
    exception: 'ข้อยกเว้น',
    unknown: 'ไม่ทราบ',
    payFail: 'ชำระเงินล้มเหลว',
    notRefund: 'N/A',
    applyRefund: 'ขอคืนเงิน',
    refundInProgress: 'กำลังคืนเงิน',
    agreeRefund: '同意退款',
    refuseRefund: '拒绝退款',
    refundedStatus: 'คืนเงินแล้ว',
    refundFail: 'คืนเงินล้มเหลว',
    cancelRefund: 'ยกเลิกการคืนเงิน',
    photo: 'ถ่ายภาพ',
    print: 'พิมพ์',
    remotePrint: 'พิมพ์ระยะไกล',
    viewRemotePhotos: 'ดูรูปภาพ',
    remotePrintPhotos: 'รูปภาพพิมพ์ระยะไกล',
    uploadPhotos: 'รูปภาพที่อัปโหลด',
    uploadPrint: 'อัปโหลดและพิมพ์',
    noPhotos: 'ไม่มีรูปภาพ',
    orderNumber: 'เลขที่คำสั่งซื้อ',
    merchant: 'ร้านค้า',
    deviceNumber: 'หมายเลขอุปกรณ์',
    payMode: 'วิธีการชำระเงิน',
    orderType: 'ประเภทคำสั่งซื้อ',
    paymentStatus: 'สถานะการชำระเงิน',
    totalPrice: 'ราคารวม',
    createTime: 'เวลาสร้าง',
    payTime: 'เวลาชำระเงิน',
    quantity: 'จำนวน',
    unitPrice: 'ราคาต่อหน่วย',
    discountAmount: 'จำนวนส่วนลด',
    refundStatus: 'สถานะการคืนเงิน',
    refundReason: 'หมายเหตุคำสั่งซื้อ',
    operation: 'การดำเนินการ',
    export: 'ส่งออก',
    orderCount: 'จำนวนคำสั่งซื้อ',
    searchPlaceholder: 'กรุณากรอกเนื้อหาการค้นหา',
    agree: '同意退款',
    refuse: '拒绝退款',
    refund: 'คืนเงิน',
    viewPhoto: 'ดูรูปภาพ',
    gifImage: 'GIF แอนิเมชัน',
    confirmAgreeRefund: 'คุณแน่ใจหรือไม่ว่าจะอนุมัติคำขอคืนเงินสำหรับคำสั่งซื้อนี้?',
    agreeRefundContent: 'หลังจากคุณคลิกตกลง คำสั่งซื้อนี้จะได้รับการคืนเงิน',
    agreeRefundSuccess: 'อนุมัติการคืนเงินคำสั่งซื้อสำเร็จ',
    confirmRefuseRefund: 'คุณแน่ใจหรือไม่ว่าจะปฏิเสธคำขอคืนเงินสำหรับคำสั่งซื้อนี้?',
    refuseRefundContent: 'หลังจากคุณคลิกตกลง คำสั่งซื้อนี้จะถูกปฏิเสธการคืนเงิน',
    refuseRefundSuccess: 'ปฏิเสธการคืนเงินคำสั่งซื้อสำเร็จ',
    deviceName: 'ชื่ออุปกรณ์',
    viewPhotos: 'รายละเอียดภาพถ่าย',
    photoDetail: 'รายละเอียดภาพถ่าย',
    compositePhotos: 'ภาพถ่ายรวม',
    originalPhotos: 'ภาพถ่ายต้นฉบับ',
    noCompositePhotos: 'ไม่มีภาพถ่ายรวม',
    noOriginalPhotos: 'ไม่มีภาพถ่ายต้นฉบับ',
    frameId: 'ID กรอบรูป',
    copyOrderCode: 'คัดลอกเลขที่คำสั่งซื้อ',
    allMerchants: 'ร้านค้าทั้งหมด',
    allDevices: 'อุปกรณ์ทั้งหมด',
    allPayModes: 'วิธีชำระเงินทั้งหมด',
    payWeixin: 'WeChat',
    payAlipay: 'Alipay',
    payShouqianba: 'Shouqianba',
    payDougong: 'Dougong',
    payYunguanjia: 'Cloud Manager',
    payLeyaoyao: 'Leyaoyao',
    payCoins: 'เหรียญ',
    payFree: 'ฟรี',
    payCoupon: 'รหัสแลก',
    payDai: 'โทเคน',
    payCoin: 'ชำระด้วยเหรียญ',
    payCash: 'เงินสด',
    payCard: 'บัตร',
    copySuccess: 'คัดลอกสำเร็จ',
    copyFail: 'คัดลอกไม่สำเร็จ'
  },
  coupon: {
    all: 'ทั้งหมด',
    notActivated: 'ยังไม่ได้เปิดใช้งาน',
    activated: 'เปิดใช้งานแล้ว',
    used: 'ใช้งานแล้ว',
    cancelled: 'ยกเลิกแล้ว',
    searchPlaceholder: 'กรุณาใส่รหัสคูปอง/ชื่อร้านค้า/ชื่ออุปกรณ์',
    export: 'ส่งออก',
    generateCoupon: 'สร้างคูปอง',
    qrCode: 'คิวอาร์โค้ด',
    noQrCode: 'ไม่มี',
    clickToPreview: 'คลิกเพื่อดูตัวอย่าง',
    couponQrCode: 'คิวอาร์โค้ดคูปอง',
    clickToDownload: 'คลิกภาพเพื่อดาวน์โหลด',
    confirmCouponInfo: 'กรุณายืนยันข้อมูลคูปอง',
    merchantName: 'ชื่อร้านค้า',
    selectMerchant: 'กรุณาเลือกร้านค้า',
    deviceObject: 'อุปกรณ์',
    selectDeviceFirst: 'กรุณาเลือกอุปกรณ์ก่อน',
    couponQuantity: 'จำนวนคูปอง',
    inputCouponQuantity: 'กรุณาใส่จำนวนคูปอง',
    activateCoupon: 'เปิดใช้งานคูปอง',
    yes: 'ใช่',
    no: 'ไม่',
    activate: 'เปิดใช้งาน',
    cancel: 'ยกเลิก',
    couponId: 'รหัสคูปอง',
    merchant: 'ร้านค้า',
    deviceName: 'ชื่ออุปกรณ์',
    couponCode: 'รหัสคูปอง',
    status: 'สถานะ',
    createTime: 'เวลาสร้าง',
    operation: 'การดำเนินการ',
    activateSuccess: 'เปิดใช้งานสำเร็จ!',
    activateFailed: 'เปิดใช้งานล้มเหลว!',
    cancelSuccess: 'ยกเลิกสำเร็จ!',
    cancelFailed: 'ยกเลิกล้มเหลว!',
    generateSuccess: 'สร้างสำเร็จ!',
    generateFailed: 'สร้างล้มเหลว!',
    generating: 'กำลังสร้างคูปอง กรุณารอสักครู่...',
    maxCouponLimit: 'ไม่สามารถสร้างคูปองมากกว่า 500 ใบในครั้งเดียว!',
    generateTip: 'สามารถสร้างได้สูงสุด 500 คูปองต่อครั้ง หากต้องการมากกว่านี้กรุณาสร้างเป็นชุด แต่ละเครื่องสามารถสร้างได้สูงสุด 2000 คูปองต่อเดือน',
    selectMerchantFirst: 'กรุณาเลือกร้านค้าก่อน!',
    downloadSuccess: 'ดาวน์โหลดสำเร็จ!',
    superCoupon: 'คูปองพิเศษ',
    setSuperCoupon: 'ตั้งเป็นคูปองพิเศษ',
    setSuperCouponConfirm: 'คุณแน่ใจหรือไม่ว่าต้องการตั้งคูปองนี้เป็นคูปองพิเศษ? คูปองพิเศษที่มีอยู่ในอุปกรณ์นี้จะถูกลดระดับเป็นคูปองธรรมดาโดยอัตโนมัติ',
    setSuperCouponSuccess: 'ตั้งคูปองพิเศษสำเร็จ!',
    setSuperCouponFailed: 'ตั้งคูปองพิเศษล้มเหลว!',
    delete: 'ลบ',
    batchDelete: 'ลบเป็นชุด',
    deleteConfirm: 'คุณแน่ใจหรือไม่ว่าต้องการลบคูปองนี้? ไม่สามารถกู้คืนได้หลังจากลบ!',
    batchDeleteConfirm: 'คุณแน่ใจหรือไม่ว่าต้องการลบคูปองที่เลือก {count} ใบ? ไม่สามารถกู้คืนได้หลังจากลบ!',
    deleteSuccess: 'ลบสำเร็จ!',
    deleteFailed: 'ลบล้มเหลว!',
    selectDeleteFirst: 'กรุณาเลือกคูปองที่ต้องการลบก่อน!'
  },
  dashboard: {
    date: 'วันที่',
    flow: 'จำนวนลูกค้า',
    companyCount: 'จำนวนร้านค้าใหม่',
    deviceCount: 'จำนวนอุปกรณ์ใหม่',
    photoCount: 'จำนวนคำสั่งถ่ายภาพ',
    printCount: 'จำนวนคำสั่งพิมพ์',
    amount: 'รายได้แพลตฟอร์มทั้งหมด',
    justSumAmount: 'ส่วนแบ่งแพลตฟอร์ม',
    companySumAmount: 'ส่วนแบ่งร้านค้า',
    lineCount: 'จำนวนอุปกรณ์ออนไลน์',
    companyName: 'ชื่อร้านค้า',
    deviceCode: 'รหัสอุปกรณ์',
    activeCode: 'รหัสอุปกรณ์',
    deviceName: 'ชื่ออุปกรณ์',
    photo: 'จำนวนคำสั่งถ่ายภาพ',
    print: 'จำนวนคำสั่งพิมพ์',
    totalPrice: 'รายได้แพลตฟอร์มทั้งหมด',
    timeCycle: 'เวลา',
    defaultTimeFilter: 'ตัวกรองเวลาเริ่มต้น (เดือน)',
    month: 'เดือน',
    week: 'สัปดาห์',
    day: 'วัน',
    search: 'ค้นหา',
    export: 'ส่งออก',
    refund: 'คืนเงิน',
    confirmRefund: 'คุณแน่ใจหรือไม่ว่าจะขอคืนเงินสำหรับคำสั่งซื้อนี้?',
    refundContent: 'หลังจากคุณคลิกตกลง คำสั่งซื้อนี้จะเริ่มคำขอคืนเงิน',
    refundSuccess: 'คำขอคืนเงินคำสั่งซื้อสำเร็จ',
    confirmAgreeRefund: 'คุณแน่ใจหรือไม่ว่าจะอนุมัติคำขอคืนเงินสำหรับคำสั่งซื้อนี้?',
    agreeRefundContent: 'หลังจากคุณคลิกตกลง คำสั่งซื้อนี้จะได้รับการคืนเงิน',
    agreeRefundSuccess: 'อนุมัติการคืนเงินคำสั่งซื้อสำเร็จ',
    confirmRefuseRefund: 'คุณแน่ใจหรือไม่ว่าจะปฏิเสธคำขอคืนเงินสำหรับคำสั่งซื้อนี้?',
    refuseRefundContent: 'หลังจากคุณคลิกตกลง คำสั่งซื้อนี้จะถูกปฏิเสธการคืนเงิน',
    refuseRefundSuccess: 'ปฏิเสธการคืนเงินคำสั่งซื้อสำเร็จ',
    timeRangeRequired: 'ช่วงเวลาไม่สามารถว่างเปล่าได้'
  },
  uiGroup: {
    uiGroupManage: 'จัดการกลุ่ม UI',
    newUIGroup: 'กลุ่ม UI ใหม่',
    searchUIName: 'ค้นหาชื่อกลุ่ม UI...',
    resourceType: 'ประเภททรัพยากร',
    adminDefine: 'กำหนดโดยผู้ดูแลระบบ',
    merchantDefine: 'กำหนดโดยร้านค้า',
    uiName: 'ชื่อ UI',
    subPageCount: 'จำนวนหน้าย่อย',
    downloadPackage: 'ดาวน์โหลดเป็นแพ็กเกจ',
    onlyOneInCategoryCannotDelete: 'เหลือกลุ่ม UI เพียงรายการเดียวในหมวดนี้ (ภาษา + สินค้า) ไม่สามารถลบได้',
    remark: 'หมายเหตุ',
    createTime: 'เวลาสร้าง',
    pageManage: 'จัดการหน้า',
    copy: 'คัดลอก',
    copyPrompt: 'คุณแน่ใจหรือไม่ว่าต้องการคัดลอกกลุ่ม UI นี้?',
    copySuccess: 'คัดลอกสำเร็จ',
    copyFail: 'คัดลอกล้มเหลว',
    copyUIGroup: 'คัดลอกกลุ่ม UI',
    originalUIName: 'ชื่อกลุ่ม UI เดิม',
    newUIName: 'ชื่อกลุ่ม UI ใหม่',
    inputNewUIName: 'กรุณากรอกชื่อกลุ่ม UI ใหม่',
    selectCompany: 'กรุณาเลือกบริษัท',
    companyName: 'ชื่อบริษัท',
    addUIGroup: 'กลุ่ม UI ใหม่',
    deletePrompt: 'คุณแน่ใจหรือไม่ว่าต้องการลบกลุ่ม UI นี้?',
    deleteSuccess: 'ลบสำเร็จ',
    editUIGroup: 'แก้ไขกลุ่ม UI',
    editSuccess: 'แก้ไขสำเร็จ',
    addSuccess: 'เพิ่มกลุ่ม UI สำเร็จ',
    addFail: 'เพิ่มกลุ่ม UI ล้มเหลว',
    newPage: 'หน้าใหม่',
    editPage: 'แก้ไขหน้า',
    addPage: 'เพิ่มหน้า',
    pageName: 'ชื่อหน้า',
    pageKey: 'คีย์หน้า',
    pageOrder: 'ลำดับหน้า',
    elementCount: 'จำนวนองค์ประกอบ',
    elementManage: 'จัดการองค์ประกอบ',
    pleaseInputPageName: 'กรุณากรอกชื่อหน้า',
    pleaseInputPageKey: 'กรุณากรอกคีย์หน้า',
    pleaseInputPageOrder: 'กรุณากรอกลำดับหน้า',
    deletePagePrompt: 'คุณแน่ใจหรือไม่ว่าต้องการลบหน้านี้? ไม่สามารถกู้คืนได้หลังจากลบ!',
    addPageSuccess: 'เพิ่มหน้าสำเร็จ',
    addPageFail: 'เพิ่มหน้าล้มเหลว',
    editPageSuccess: 'แก้ไขหน้าสำเร็จ',
    editPageFail: 'แก้ไขหน้าล้มเหลว',
    deletePageSuccess: 'ลบหน้าสำเร็จ',
    deletePageFail: 'ลบหน้าล้มเหลว',
    pageKeyExists: 'คีย์หน้ามีอยู่แล้ว กรุณาเปลี่ยน',
    productType: 'ประเภทสินค้า',
    elementName: 'ชื่อองค์ประกอบ',
    elementType: 'ประเภทองค์ประกอบ',
    allElement: 'องค์ประกอบทั้งหมด',
    editElement: 'แก้ไของค์ประกอบ',
    addElement: 'เพิ่มองค์ประกอบ',
    elementValue: 'ค่าองค์ประกอบ',
    elementValueMsg: 'กรุณากรอกค่าองค์ประกอบ',
    elementKey: 'คีย์องค์ประกอบ',
    elementKeyMsg: 'กรุณากรอกคีย์องค์ประกอบ',
    elementKeyPlaceholder: 'คีย์องค์ประกอบไม่สามารถซ้ำกันในหน้าเดียวกัน แนะนำให้ใช้ตัวอักษรและขีดล่าง',
    elementNameMsg: 'กรุณากรอกชื่อองค์ประกอบ',
    elementTypeMsg: 'กรุณาเลือกประเภทองค์ประกอบ',
    elementKeyError: 'คีย์องค์ประกอบมีอยู่แล้วในหน้าปัจจุบัน กรุณาเปลี่ยน',
    elemnetDeleteTips: 'คุณแน่ใจหรือไม่ว่าต้องการลบองค์ประกอบนี้?',
    batchEditElement: 'แก้ไของค์ประกอบเป็นชุด',
    horizontalLayout: 'เลย์เอาต์แนวนอน',
    verticalLayout: 'เลย์เอาต์แนวตั้ง',
    loadingElementList: 'กำลังโหลดรายการองค์ประกอบ...',
    allResourceType: 'ประเภททรัพยากรทั้งหมด',
    pleaseInputUIName: 'กรุณากรอกชื่อกลุ่ม UI',
    pleaseSelectResourceType: 'กรุณาเลือกประเภททรัพยากร',
    previewImage: 'รูปภาพตัวอย่าง',
    reupload: 'อัปโหลดใหม่',
    uploadPreviewImage: 'อัปโหลดรูปตัวอย่าง',
    languageType: 'ภาษา',
    selectLanguageType: 'กรุณาเลือกภาษา',
    pageSize: 'ขนาดหน้า',
    pixelWH: 'พิกเซล (กว้าง×สูง)',
    belongCompany: 'ร้านค้า',
    cancelDefaultConfirm: 'คุณแน่ใจหรือไม่ว่าต้องการยกเลิกสถานะเริ่มต้นของกลุ่ม UI นี้?',
    setDefaultConfirm: 'คุณแน่ใจหรือไม่ว่าต้องการตั้งกลุ่ม UI นี้เป็นค่าเริ่มต้น?',
    operateSuccess: 'ดำเนินการสำเร็จ!',
    operateFail: 'ดำเนินการล้มเหลว',
    onlyJpgPng: 'อัปโหลดได้เฉพาะรูปภาพ JPG และ PNG เท่านั้น!',
    exceed4M: 'ขนาดรูปภาพต้องไม่เกิน 4MB!',
    uploadSuccess: 'อัปโหลดสำเร็จ',
    uploadSuccessNoUrl: 'อัปโหลดสำเร็จแต่ไม่สามารถรับ URL รูปภาพได้',
    inputImageUrlPlaceholder: 'หรือกรอกที่อยู่รูปภาพโดยตรง (http/https)',
    useImageUrl: 'ใช้ที่อยู่นี้',
    invalidImageUrl: 'กรุณากรอกที่อยู่รูปภาพที่ถูกต้อง (ขึ้นต้นด้วย http:// หรือ https://)',
    imageUrlApplied: 'ใช้ที่อยู่รูปภาพแล้ว',
    pasteTip: 'เคล็ดลับ: หลังคัดลอกรูปภาพหรือจับภาพหน้าจอ กด Ctrl+V/Cmd+V เพื่อวางและอัปโหลด',
    pasteUploadSuccess: 'อัปโหลดรูปภาพที่วางสำเร็จ',
    langZhCN: 'จีนตัวย่อ',
    langEn: 'อังกฤษ',
    langFr: 'ฝรั่งเศส',
    langKo: 'เกาหลี',
    langZhTW: 'จีนตัวเต็ม',
    langVi: 'เวียดนาม',
    langAr: 'อาหรับ',
    langBih: 'บอสเนีย',
    langTh: 'ไทย',
    langDe: 'เยอรมัน',
    langEs: 'สเปน'
  },
  deviceSetup: {
    title: 'ตั้งค่าเครื่อง',
    basicInfo: 'ข้อมูลพื้นฐานของเครื่อง',
    machineModelSN: 'รุ่นเครื่อง [SN]',
    inputMachineSN: 'กรุณากรอกรหัส SN ของเครื่อง',
    machineName: 'ชื่อเครื่อง',
    inputMachineName: 'กรุณากรอกชื่อเครื่อง',
    machineCode: 'รหัสเครื่อง',
    inputMachineCode: 'กรุณากรอกรหัสเครื่อง',
    machineAddress: 'ที่อยู่เครื่อง',
    inputMachineAddress: 'กรุณากรอกที่อยู่เครื่อง',
    activationCode: 'รหัสเปิดใช้งาน',
    h5Url: 'URL หน้า H5',
    parseUrl: 'แยกวิเคราะห์ URL',
    urlEditorTitle: 'จัดการพารามิเตอร์ URL H5',
    urlBase: 'URL หลัก',
    urlParams: 'พารามิเตอร์ URL',
    paramName: 'ชื่อพารามิเตอร์',
    paramValue: 'ค่าพารามิเตอร์',
    addParam: 'เพิ่มพารามิเตอร์',
    noParams: 'ยังไม่มีพารามิเตอร์ คลิก "เพิ่มพารามิเตอร์"',
    done: 'เสร็จสิ้น',
    pasteTip: 'เคล็ดลับ: หลังคัดลอกรูปภาพหรือถ่ายภาพหน้าจอ กด Ctrl+V เพื่อวางและอัปโหลด',
    pasteUploadSuccess: 'อัปโหลดรูปภาพที่วางสำเร็จ',
    filterByCompany: 'กรองตามร้านค้า',
    customerServicePhone: 'เบอร์บริการลูกค้า',
    photoAccessType: 'วิธีเข้าถึงรูปภาพ',
    selectPhotoAccessType: 'กรุณาเลือกประเภท',
    paymentMode: 'โหมดการชำระเงิน',
    selectPaymentMode: 'กรุณาเลือกประเภท',
    onlinePayment: 'ชำระเงินออนไลน์',
    offlineCoin: 'เหรียญออฟไลน์',
    scanQRCode: 'สแกนคิวอาร์โค้ด',
    addFriend: 'เพิ่มเพื่อน',
    machineSettings: 'การตั้งค่าเครื่อง',
    uiGroupSelection: 'เลือกกลุ่ม UI',
    selectUiGroup: 'กรุณาเลือกกลุ่ม UI',
    uiSelection: 'เลือก UI',
    searchUiName: 'ค้นหาชื่อ UI',
    viewAll: 'ทั้งหมด',
    viewSelected: 'เฉพาะที่เลือก',
    builtIn: 'ในตัว',
    notBuiltIn: 'ไม่ใช่ในตัว',
    productSelection: 'เลือกสินค้า',
    searchProductName: 'ค้นหาชื่อสินค้า',
    selectAll: 'เลือกทั้งหมด',
    frameSelection: 'เลือกกรอบรูป',
    selectProductFirst: 'กรุณาเลือกสินค้าก่อน',
    searchFrameName: 'ค้นหาชื่อกรอบรูป',
    noProductSelected: 'กรุณาเลือกอย่างน้อยหนึ่งสินค้าก่อน แล้วเลือกสินค้าเพื่อดูกรอบรูปที่เกี่ยวข้อง',
    noFrameData: 'ไม่มีข้อมูลกรอบรูปสำหรับสินค้านี้',
    filterSelection: 'เลือกฟิลเตอร์',
    searchFilterName: 'ค้นหาชื่อฟิลเตอร์',
    stickerGroup: 'กลุ่มสติ๊กเกอร์',
    searchGroupName: 'ค้นหาชื่อกลุ่ม',
    noStickerGroupData: 'ไม่มีข้อมูลกลุ่มสติ๊กเกอร์',
    stickersCount: '{count} สติ๊กเกอร์',
    parameterSettings: 'การตั้งค่าพารามิเตอร์',
    photoTime: 'เวลาถ่ายภาพ',
    seconds: 'วินาที',
    inputPhotoTime: 'กรุณากรอกเวลาถ่ายภาพ',
    intervalTime: 'ช่วงเวลาถ่ายภาพ',
    inputIntervalTime: 'กรุณากรอกช่วงเวลา',
    paperCount: 'จำนวนกระดาษ',
    sheets: 'แผ่น',
    inputPaperCount: 'กรุณากรอกจำนวนกระดาษ',
    paperCountRequired: 'ต้องกรอกจำนวนกระดาษ',
    cancel: 'ยกเลิก',
    save: 'บันทึก',
    selectAtLeastOneProduct: 'กรุณาเลือกอย่างน้อยหนึ่งสินค้า',
    selectAtLeastOneFilter: 'กรุณาเลือกอย่างน้อยหนึ่งฟิลเตอร์',
    paperCountMinLimit: 'จำนวนกระดาษต้องไม่ต่ำกว่า 50',
    serverConnectionError: 'การเชื่อมต่อเซิร์ฟเวอร์ผิดพลาด กรุณาลองใหม่ภายหลัง!',
    deviceThumbnail: 'รูปขนาดย่อของอุปกรณ์',
    modify: 'แก้ไข',
    upload: 'อัปโหลด',
    remoteDesktopInfo: 'ข้อมูลรีโมทเดสก์ท็อป',
    remoteDesktopPlaceholder: 'กรุณากรอกข้อมูลรีโมทเดสก์ท็อป (รหัสรีโมท)',
    format: 'จัดรูปแบบ',
    belongCategory: 'หมวดหมู่',
    selectBelongCategory: 'กรุณาเลือกหมวดหมู่',
    onlyJpgPng: 'อัปโหลดได้เฉพาะรูปภาพ JPG และ PNG เท่านั้น~',
    exceed4M: 'เกินขีดจำกัด 4M ไม่อนุญาตให้อัปโหลด~',
    thumbnailUploadFailed: 'อัปโหลดรูปขนาดย่อล้มเหลว',
    jsonFormatErrorFormat: 'รูปแบบ JSON ไม่ถูกต้อง ไม่สามารถจัดรูปแบบได้ กรุณาตรวจสอบแล้วลองใหม่',
    jsonFormatError: 'รูปแบบ JSON ไม่ถูกต้อง กรุณาตรวจสอบแล้วลองใหม่',
    showName: 'ชื่อที่แสดงของอุปกรณ์ (สแกนคิวอาร์โค้ดเพื่อดาวน์โหลดชื่อหน้ารูปภาพอิเล็กทรอนิกส์)',
    showNamePlaceholder: 'แสดงเป็นชื่อบนหน้าดาวน์โหลดรูปภาพอิเล็กทรอนิกส์'
  },
  personal: {
    oldPassword: 'รหัสผ่านเก่า',
    inputOldPassword: 'กรุณาใส่รหัสผ่านเก่า',
    strength: 'ความแข็งแรง: ',
    passwordTip: 'กรุณาใส่อย่างน้อย 6 ตัวอักษร อย่าใช้รหัสผ่านที่เดาง่าย',
    newPassword: 'รหัสผ่านใหม่',
    passwordPlaceholder: 'อย่างน้อย 6 ตัวอักษร แบ่งตัวพิมพ์ใหญ่/เล็ก',
    confirmPassword: 'ยืนยันอีกครั้ง',
    confirmPasswordPlaceholder: 'ยืนยันรหัสผ่าน',
    levelLow: 'ต่ำ',
    levelMedium: 'กลาง',
    levelStrong: 'แข็งแรง',
    minSixChars: 'กรุณาใส่รหัสผ่านอย่างน้อย 6 ตัวอักษร',
    strengthNotEnough: 'ความแข็งแรงรหัสผ่านไม่เพียงพอ',
    inputPassword: 'กรุณาใส่รหัสผ่าน',
    passwordNotMatch: 'รหัสผ่านสองครั้งไม่ตรงกัน',
    oldPasswordIncorrect: 'รหัสผ่านเก่าไม่ถูกต้อง',
    editProfile: 'แก้ไขโปรไฟล์',
    updateAvatar: 'เปลี่ยนรูปแทนตัว',
    avatarAlt: 'รูปแทนตัว',
    avatarUpdateSuccess: 'เปลี่ยนรูปแทนตัวสำเร็จ',
    email: 'อีเมล',
    mobile: 'มือถือ',
    dept: 'แผนก',
    gender: 'เพศ',
    description: 'คำอธิบาย',
    inputEmail: 'กรุณาใส่อีเมล',
    inputMobile: 'กรุณาใส่หมายเลขมือถือ',
    emailInvalid: 'กรุณาใส่อีเมลที่ถูกต้อง',
    emailMax: 'ความยาวต้องไม่เกิน 50 ตัวอักษร',
    mobileInvalid: 'กรุณาใส่หมายเลขมือถือที่ถูกต้อง',
    selectGender: 'กรุณาเลือกเพศ',
    descMax: 'ความยาวต้องไม่เกิน 100 ตัวอักษร',
    submit: 'ส่ง',
    selectAvatar: 'เลือกรูปแทนตัว',
    clickToSelect: 'คลิกเพื่อเลือก',
    updatingWarning: 'กำลังเปลี่ยนรูปแทนตัว กรุณาอย่าคลิกซ้ำ',
    updateAvatarFailed: 'อัปเดตรูปแทนตัวล้มเหลว',
    tabHthz: 'Houtian Huazi',
    tabAl: 'ซีรีส์ Ali',
    tabLm: 'LianMeng'
  },
  userInfo: {
    title: 'ข้อมูลผู้ใช้',
    account: 'บัญชี: ',
    role: 'บทบาท: ',
    noRole: 'ยังไม่มีบทบาท',
    male: 'ชาย',
    female: 'หญิง',
    confidential: 'ปกปิด',
    department: 'แผนก: ',
    noDepartment: 'ยังไม่มีแผนก',
    gender: 'เพศ: ',
    phone: 'โทรศัพท์: ',
    noPhone: 'ยังไม่ได้ผูกโทรศัพท์',
    email: 'อีเมล: ',
    noEmail: 'ยังไม่ได้ผูกอีเมล',
    status: 'สถานะ: ',
    locked: 'ล็อก',
    valid: 'ใช้งาน',
    createTime: 'สร้างเมื่อ: ',
    lastLogin: 'เข้าสู่ระบบล่าสุด: ',
    description: 'คำอธิบาย: '
  },
  remotePrint: {
    loading: 'กำลังโหลด...',
    expired: 'บันทึกหมดอายุ',
    expiredDesc: 'บันทึกการอัปโหลดนี้หมดอายุแล้ว กรุณากลับไปที่ตู้แล้วลองใหม่',
    completed: 'เสร็จสมบูรณ์',
    completedDesc: 'ส่งรูปภาพสำเร็จ กรุณารอการพิมพ์ที่ตู้',
    submitted: 'ส่งสำเร็จ',
    submittedDesc: 'ส่งรูปภาพไปยังตู้แล้ว กรุณาทำขั้นตอนต่อไปที่เครื่อง',
    orderInfo: 'ข้อมูลคำสั่งซื้อ',
    recordCode: 'เลขที่บันทึก',
    orderCode: 'เลขที่คำสั่งซื้อ',
    product: 'สินค้า',
    price: 'ราคา',
    expireTime: 'หมดอายุเมื่อ',
    photos: 'รูปภาพ',
    addPhoto: 'เพิ่มรูปภาพ',
    tipFormat: 'รองรับเฉพาะรูปภาพ JPG/PNG',
    tipSize: 'แต่ละรูปไม่เกิน 3MB',
    tipExpire: 'บันทึกมีอายุ 5 นาที กรุณาอัปโหลดโดยเร็ว',
    submit: 'อัปโหลดและพิมพ์',
    submitting: 'กำลังส่ง...',
    noRecordCode: 'ไม่มีเลขที่บันทึก กรุณาสแกน QR Code',
    loadFailed: 'โหลดล้มเหลว กรุณาลองใหม่',
    invalidFormat: 'รองรับเฉพาะ JPG/PNG',
    photoLimit: 'อัปโหลดได้สูงสุด {count} รูป',
    fileTooLarge: 'ขนาดไฟล์ต้องไม่เกิน 10MB',
    uploadFailed: 'อัปโหลดล้มเหลว กรุณาลองใหม่',
    noPhotoUploaded: 'กรุณาอัปโหลดอย่างน้อย 1 รูป',
    submitFailed: 'ส่งล้มเหลว กรุณาลองใหม่'
  }
}



// WEBPACK FOOTER //
// ./src/lang/th-TH.js